import { generateId } from "../utils";
import { TableEditorConfig } from "./dto";

const COL = {
  DEFAAULT_WIDTH: 100,
  MIN_WIDTH: 40,
  MAX_WIDTH: Infinity,
};
const ROW = {
  DEFAAULT_HEIGHT: 40,
  MIN_HEIGHT: 40,
  MAX_HEIGHT: 260,
};
// 数据类型
const VALUE_TYPE = {
  // 文本
  TEXT: "string",
  // 数字
  NUMBER: "number",
  // 日期
  DATE: "date",
  // 日期范围
  DATERANGE: "daterange",
  // 文件
  FILE: "file",
  // 图片
  IMAGE: "image",
} as const;
// 取值类型
const DATA_TYPE = {
  // 格式化
  FORMAT: "format",
  // 动态
  DYNAMIC: "dynamic",
  // 公式
  FORMULA: "formula",
} as const;
// 公式类型
const FORMULA_TYPE = {
  // 文本
  TEXT: "text",
  // 数字
  NUMBER: "number",
  // 动态
  DYNAMIC: "dynamic",
  // 符号
  OPERATOR: "operator",
} as const;

// 空模板
const EMPTY_TMPL: TableEditorConfig = {
  loops: [],
  formulas: [],
  cols: Array(8).fill(120),
  rows: Array.from({ length: 8 }, () => ({
    id: generateId(),
    cells: Array.from({ length: 8 }, () => ({
      id: generateId(),
      colSpan: 1,
      rowSpan: 1,
    })),
  })),
};
// 序号
const INDEX = {
  content: "序号",
  code: "$i",
};

export { COL, ROW, VALUE_TYPE, DATA_TYPE, FORMULA_TYPE, EMPTY_TMPL, INDEX };
